<ng-container *ngIf="documentService.document.page_count === 0">
  <div class="flex-container" style="padding: 60px 0">
    <div class="flex-cell"></div>
    <div class="document-preview-error flex-container vertical-center">
      <i class="material-icons">restore_page</i>
      <div>
        <div class="message">Document preview not available</div>
      </div>
    </div>
    <div class="flex-cell"></div>
  </div>
</ng-container>

<fl-message-box
  [type]="messageBoxType.Alert"
  *ngIf="documentService.deletionState[0] === DocumentFieldDeletionStatus.Failed"
>
  <p>

    {{ documentService.deletionState[1] }}
  </p>
</fl-message-box>

<div *ngFor="let page of documentService.document.pages" class="page">
  <img #image [src]="page.image" (load)="loadMapper(image, mapper)" />
  <div class="page--page-number">
    {{ page.index + 1 }}
  </div>
  <fl-mapper #mapper [page]="page" class="component-selectable" [attr.data-selectable-type]="'mapper'">
  </fl-mapper>
</div>
